import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import MainMenu from "../MainMenu";
import MobileMenu from "../MobileMenu";
import initialiseGA from "@/utils/initialiseGA.js";

const Header1 = () => {
  const [navbar, setNavbar] = useState(false);
  initialiseGA();

  const changeBackground = () => {
    if (window.scrollY >= 10) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  return (
    <>
      {" "}
      <header className={`header ${navbar ? "is-sticky bg-white" : ""}`}>
        <div className="header__container header__container-1500 mx-auto px-30 sm:px-20 align-items-center w-100">
          <div className="row justify-between items-center">
            <div className="col-auto">
              <div className="d-flex items-center">
                <Link to="/" className="header-logo">
                  <img src="/img/general/logo.svg" alt="logo" style={{width: '10vh'}} className={"mr-20"} />
                  {/*tripsi.pl*/}
                  {/*<img src="/img/general/logo-dark-3.svg" alt="logo icon" />*/}
                </Link>
                {/* End logo */}

                <div className="header-menu">
                  <div className="header-menu__content">
                    <MainMenu style="text-dark-1" />
                  </div>
                </div>
                {/* End header-menu */}
              </div>
              {/* End d-flex */}
            </div>
            {/* End col */}

            <div className="col-auto">
              <div className="d-flex items-center">
                <div className="d-flex items-center is-menu-opened-hide md:d-none">
                  {/*<Link*/}
                  {/*  to="/login"*/}
                  {/*  className="button px-30 fw-400 text-14 -blue-1 bg-dark-4 h-50 text-white"*/}
                  {/*>*/}
                  {/*  Become An Expert*/}
                  {/*</Link>*/}
                  {/*<Link*/}
                  {/*  to="/signup"*/}
                  {/*  className="button px-30 fw-400 text-14 border-dark-4 -blue-1 h-50 text-dark-4 ml-20"*/}
                  {/*>*/}
                  {/*  Sign In / Register*/}
                  {/*</Link>*/}
                </div>
                {/* End d-flex */}

                {/* Start mobile menu icon */}
                <div className="d-none xl:d-flex x-gap-20 items-center pl-30 text-dark-1">
                  <div>
                    {/*<Link*/}
                    {/*  to="/login"*/}
                    {/*  className="d-flex items-center icon-user text-inherit text-22"*/}
                    {/*/>*/}
                  </div>
                  <div>
                    <button
                      className="d-flex items-center icon-menu text-inherit text-20"
                      data-bs-toggle="offcanvas"
                      aria-controls="mobile-sidebar_menu"
                      data-bs-target="#mobile-sidebar_menu"
                      aria-label="Otwórz menu"
                    />

                    <div
                      className="offcanvas offcanvas-start  mobile_menu-contnet"
                      tabIndex="-1"
                      id="mobile-sidebar_menu"
                      aria-labelledby="offcanvasMenuLabel"
                      data-bs-scroll="true"
                    >
                      <MobileMenu />
                      {/* End MobileMenu */}
                    </div>
                  </div>
                </div>
                {/* End mobile menu icon */}
              </div>
              {/* End d-flex */}
            </div>
            {/* End col-auto */}
          </div>
          {/* End .row */}
        </div>
        {/* End header_container */}
      </header>
      {/* End header */}
    </>
  );
};

export default Header1;
